import PermissionGuard from 'components/Global/PermissionGuard';
import LeaveManagementComponent from 'components/Settings/Masters/LeaveManagement';
export const LeaveManagement = () => {
	return (
		<PermissionGuard permission="Allow_Leave_Management">
			<LeaveManagementComponent />
		</PermissionGuard>
	);
};
